import {defineStore} from 'pinia';
import {ref} from 'vue';
import {useLocalStorage} from '@vueuse/core';

export const useZoomLockStore = defineStore('zoomLock', () => {
  const isLocked = useLocalStorage('diff-list-zoom-lock', false);
  // The last zoom level reached on any sheet, by gesture or by navigation.
  const scale = ref<number | null>(null);

  function toggle() {
    isLocked.value = !isLocked.value;
  }

  function recordScale(newScale: number) {
    scale.value = newScale;
  }

  return {
    isLocked,
    scale,
    toggle,
    recordScale,
  };
});
